import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { yupResolver } from '@hookform/resolvers/yup';
import { Modal, Form, Row, Col, Image, Button } from 'react-bootstrap';

import LoaderBtn from '@components/LoaderBtn/loaderBtn';
import InputGroupText from '@components/InputGroupText/InputGroupText';

import {
    cancelButtonColor,
    confirmButtonColor,
} from '@constants/general.const';

import { faSuitcase } from '@fortawesome/pro-light-svg-icons';
import JobIcon from '@images/job-icon.svg';

import { updateCurrentStep } from '@app/Auth/Login/loginSlice';
import { addJobTitleData } from '@app/CreateOrganization/step5/functions';

import { IStep5Props } from './step5.interface';

const JobTitlePopupStep5 = ({
    show,
    getData,
    handleClose,
    organizationId,
}: any) => {
    const dispatch = useDispatch<any>();

    const { jobTitleStep5Data } = useSelector((state: any) => state);
    const { jobTitleData, isAddJobTitleData } = jobTitleStep5Data;

    const schema = Yup.object({
        job_title: Yup.string().required('Job Title is a required field'),
    }).required();

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors, isDirty },
    } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: jobTitleData,
        mode: 'onBlur',
    });

    const HandleChange = async (data: IStep5Props) => {
        const sendData = { ...data, nanoId: organizationId };
        const { payload } = await dispatch(addJobTitleData(sendData));
        const { data: payloadData } = payload || {};
        if (payloadData?.message !== '' && payloadData?.status) {
            dispatch(updateCurrentStep(payload));
            getData();
            handleClose();
            setValue('job_title', '');
        } else {
            toast.error(payload?.message);
        }
    };

    const onClose = async () => {
        if (isDirty) {
            Swal.fire({
                title: 'Warning',
                html:
                    'Are you sure you want to close this form? <br/> ' +
                    'All changes made will be lost.',
                allowOutsideClick: false,

                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: cancelButtonColor,
                confirmButtonColor: confirmButtonColor,
                cancelButtonText: 'No',
                confirmButtonText: 'Yes',
            }).then(async (result) => {
                if (result?.isConfirmed) {
                    handleClose();
                    setValue('job_title', '');
                }
            });
        } else {
            handleClose();
            setValue('job_title', '');
        }
    };

    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title className="fs-5 fw-semibold">
                    Add New Job Titles
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <Form onSubmit={handleSubmit(HandleChange)}>
                    <Row className="justify-content-center">
                        <Col md={12} className="text-center">
                            <Image src={JobIcon} alt="building icon" />
                        </Col>
                        <Col md={12} className="my-3">
                            <Controller
                                name={`job_title`}
                                control={control}
                                render={({
                                    field: { onChange, value },
                                }: any) => (
                                    <>
                                        <InputGroupText
                                            onChangeFunc={onChange}
                                            value={value}
                                            id={`job_title`}
                                            inputName={`job_title`}
                                            inputType={'text'}
                                            placeholder={'Job Title'}
                                            label={null}
                                            tabIndex={1}
                                            inputGroupClassName="mfnw__input-group"
                                            icon={faSuitcase}
                                            disabled={false}
                                            autoFocus={true}
                                            errorText={
                                                errors?.job_title?.message
                                            }
                                        />
                                    </>
                                )}
                            />
                        </Col>
                        <Col md={12}>
                            <Button
                                variant="primary w-100 mt-3 text-uppercase"
                                className="button__details"
                                type="submit"
                                tabIndex={2}
                                disabled={isAddJobTitleData}
                            >
                                {isAddJobTitleData ? <LoaderBtn /> : 'SAVE'}
                            </Button>
                            <Button
                                className="btn-cancel mt-4 w-100 text-uppercase fw-semibold"
                                onClick={() => onClose()}
                                tabIndex={3}
                            >
                                CANCEL
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default JobTitlePopupStep5;
